import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AppLayout from "../components/AppLayout";

const diaries = [
  ["headache", "Cefaleia", "Dias com ou sem dor, com detalhes opcionais quando houver crise."],
  ["blood_pressure", "Pressão arterial", "Aferições avulsas; um protocolo de MRPA precisa ser configurado à parte."],
  ["glucose", "Glicemia", "Medidas com horário e contexto, como jejum ou após refeição."],
];

export default function NovoDiario() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "", email: "", diary_type: "headache", goal_type: "duration",
    target_days: "30", target_count: "20", start_date: new Date().toLocaleDateString("en-CA"), return_date: "",
  });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const diary = diaries.find(([value]) => value === form.diary_type);

  function change(key, value) {
    setForm((current) => ({ ...current, [key]: value }));
  }

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const response = await fetch("/api/followups", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...form,
          target_days: Number(form.target_days),
          target_count: Number(form.target_count),
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.error || "Não foi possível criar o acompanhamento.");
      navigate("/app", { state: { createdPatient: result.patient?.name || form.name, createdPatientId: result.patient?.id } });
    } catch (cause) {
      setError(cause.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AppLayout>
      <section className="formulario-coluna create-followup">
        <Link className="link-discreto" to="/app">← Voltar ao painel</Link>
        <p className="sobretitulo">Novo acompanhamento</p>
        <h1>Quem você vai acompanhar?</h1>
        <p>Peça apenas o necessário. O paciente recebe um convite pessoal e decide quando ativar o diário.</p>
        <form onSubmit={submit}>
          <div className="form-section-heading"><span>01</span><div><strong>Paciente</strong><small>Nome e e-mail para o convite</small></div></div>
          <label>Nome para identificar<input required maxLength="100" autoComplete="name" value={form.name} onChange={(event) => change("name", event.target.value)} /></label>
          <label>E-mail<input required type="email" maxLength="254" autoComplete="email" value={form.email} onChange={(event) => change("email", event.target.value)} /><small>Usado somente para enviar o convite de acesso.</small></label>

          <div className="form-section-heading"><span>02</span><div><strong>Diário</strong><small>O paciente poderá alternar entre acompanhamentos ativos</small></div></div>
          <div className="diary-options" role="radiogroup" aria-label="Tipo de diário">
            {diaries.map(([value, title, description]) => (
              <button type="button" role="radio" aria-checked={form.diary_type === value} className={`diary-option ${form.diary_type === value ? "selected" : ""}`} key={value} onClick={() => change("diary_type", value)}>
                <span className="radio-mark" aria-hidden="true" /><span><strong>{title}</strong><small>{description}</small></span>
              </button>
            ))}
          </div>
          <p className="diary-note">{diary?.[1] === "Pressão arterial" ? "Acompanhamento livre não é MRPA formal. Não selecione protocolos que não tenham sido configurados." : "Os dados são informados pelo paciente e não geram diagnóstico automático."}</p>

          <div className="form-section-heading"><span>03</span><div><strong>Objetivo</strong><small>Você pode ajustar o acompanhamento depois</small></div></div>
          <label>Como encerrar esta etapa?<select value={form.goal_type} onChange={(event) => change("goal_type", event.target.value)}><option value="duration">Por período</option><option value="quantity">Por número de registros</option><option value="return_date">Por data de retorno</option><option value="continuous">Contínuo, sem prazo definido</option></select></label>
          {form.goal_type === "duration" && <label>Duração em dias<input type="number" min="1" max="365" required value={form.target_days} onChange={(event) => change("target_days", event.target.value)} /></label>}
          {form.goal_type === "quantity" && <label>Quantidade de registros<input type="number" min="1" max="5000" required value={form.target_count} onChange={(event) => change("target_count", event.target.value)} /></label>}
          <div className="form-row">
            <label>Início<input type="date" required value={form.start_date} onChange={(event) => change("start_date", event.target.value)} /></label>
            {form.goal_type !== "return_date" && <label>Data para reavaliar <span>(opcional)</span><input type="date" value={form.return_date} onChange={(event) => change("return_date", event.target.value)} /></label>}
            {form.goal_type === "return_date" && <label>Data de retorno<input type="date" required value={form.return_date} onChange={(event) => change("return_date", event.target.value)} /></label>}
          </div>
          {error && <p className="erro" role="alert">{error}</p>}
          <button className="botao primario form-submit" disabled={busy}>{busy ? "Criando…" : "Criar e preparar convite"}</button>
          <small className="form-footnote">A meta atingida não encerra o acompanhamento automaticamente.</small>
        </form>
      </section>
    </AppLayout>
  );
}
